import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/photo/critical_mass.webp'
import _imports_1 from '../../assets/photo/nature.webp'
import _imports_2 from '../../assets/photo/view.webp'
import _imports_3 from '../../assets/logo/mitfuer.jpg'
import _imports_4 from '../../assets/logo/greenpeace.jpg'


const _withScopeId = n => (_pushScopeId("data-v-a70199e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "splash-img",
  style: {"background-image":"url(/assets/img/splash/sambatrasse.webp)"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "parallelogram-clip" }, "Buga+", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ein Radwegering für Wuppertal", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Urbaner Radverkehr ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Durch ein konsistentes Radwegenetz wird das Fahrrad als Verkehrsmittel im Alltag deutlich attraktiver und gibt mehr Menschen einen Anreiz für klimafreundliche Mobilität. ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Einbindung der Naturräume ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Viele der tollen Wuppertaler Wälder und Parks werden durch den Radwegering verbunden und laden zum Verweilen in der Natur ein. ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Wuppertal entdecken ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Während der Bundesgartenschau 2031 bietet der Radweg die Möglichkeit Kernareale wie die Königshöhe mit dem Fahrrad zu erkunden. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Eine Initiative von ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://mitfuerheck.net",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://greenwire.greenpeace.de/greenpeace-wuppertal",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_transparent_logos = _resolveComponent("transparent-logos")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_info_footer = _resolveComponent("info-footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { fullscreen: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'large-title': true, mobile: _ctx.LayoutService.state.mobile })
            }, _hoisted_4, 2),
            (!_ctx.LayoutService.state.mobile)
              ? (_openBlock(), _createBlock(_component_transparent_logos, {
                  key: 0,
                  style: {"margin-right":"1rem"},
                  class: "transparent-logos"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, { to: "/karte" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  id: "discover-button",
                  class: _normalizeClass({
              mobile: _ctx.LayoutService.state.mobile,
              'large-button': true,
            })
                }, " Karte entdecken >> ", 2)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card, { class: "concept-card" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "concept-card" }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "concept-card" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                id: "concept-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/konzept'))),
                class: _normalizeClass({ mobile: _ctx.LayoutService.state.mobile, 'large-button': true })
              }, " Zum Konzept >> ", 2)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card, { class: "initiative" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, { class: "ion-text-center" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_info_footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}